import React from 'react';
import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import  {GiHamburgerMenu} from "react-icons/gi";
import { IoIosSearch,IoMdSave,IoMdArrowDropdown } from "react-icons/io";
import { HiOutlineShoppingCart,HiUserCircle } from "react-icons/hi";


import { BestBuyContext } from "../context/BestBuyContext";
import { useState } from "react";
import { useEffect } from "react";
function Navigation() {
  //   const LinkStyle = {
  //     color: "white",
  //     backgroundColor: "purple",
  //     padding: "10px",
  //     fontSize: "14px",
  //     borderRadius: "5px",
  //     display: "inline-block",
  //     margin: "10px",
  //   };

  const [toggleNav ,setToggleNav]=useState(false)
const {cart,userName} = useContext(BestBuyContext)

  const handleClickNav =()=>{
    setToggleNav(current=>!current)
  }

  useEffect(()=>{
    // return()=>{
    //   setToggleNav(false)
    // }
  },[])
  return (
<>
    <nav className="navbar navbar-expand-lg  sticky-top border-bottom">
  <div className="container-fluid">
<Link to ="/"><svg aria-label="BestBuy.com" role="img" className="block" height="40" width="68" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 92"><path d="M127.6 66.66h31.33v25.09h-31.34l-7.8-7.34V74.06l7.81-7.4z" fill="#fff200"></path><path d="M126.03 79.19c0 .86-.69 1.55-1.55 1.55-.86 0-1.55-.69-1.55-1.55 0-.86.69-1.55 1.55-1.55.85 0 1.55.7 1.55 1.55z" fill="#1d252c"></path><path d="M127.2 57.76c0-1.17.94-2.12 2.12-2.12 1.2 0 2.12.94 2.12 2.11 0 1.19-.93 2.11-2.12 2.11-1.17 0-2.12-.9-2.12-2.1zm3.96-.01c0-1.07-.78-1.85-1.84-1.85-1.05 0-1.83.79-1.83 1.86 0 1.08.81 1.84 1.83 1.84 1.04 0 1.84-.77 1.84-1.85zm-2.55-1.13h.71c.48 0 .79.21.79.64v.01c0 .33-.21.51-.51.57l.64.97h-.35l-.61-.92h-.33v.92h-.33l-.01-2.19zm.72 1.03c.31 0 .46-.12.46-.37v-.01c0-.28-.16-.37-.46-.37h-.38v.75h.38zM30.21 19.81l.61-.22c5.92-3.18 6.93-11.05 1.16-15.36-2.58-2.06-6.09-3.09-10.55-3.09H2.1v39.61h20.47c5.25 0 16.12-.98 16.12-11.33-.01-7.91-8.29-9.54-8.48-9.61zM14.9 10.42h4.72c1.74-.04 3.23 1.18 3.21 2.9.02 1.73-1.48 2.94-3.21 2.9H14.9v-5.8zm8.82 20.12c-.74.7-1.67 1.04-2.78 1.04H14.9v-7.11h6.03c3.28-.18 5.27 3.8 2.79 6.07zM40.39 63.65l.61-.22c5.92-3.18 6.93-11.05 1.16-15.36-2.58-2.06-6.1-3.09-10.55-3.09h-19.3v39.61h20.43c5.25 0 16.12-.98 16.12-11.33 0-7.91-8.28-9.53-8.47-9.61zm-15.27-9.39h4.68c1.74-.04 3.23 1.18 3.22 2.9.01 1.73-1.48 2.94-3.22 2.9h-4.68v-5.8zm8.78 20.13c-.74.7-1.67 1.04-2.78 1.04h-6v-7.11h6c3.27-.18 5.26 3.8 2.78 6.07zM71.48 31.13H52.33v-6.21h15.63v-9.06H52.33v-5.08h19.19V1.13h-32v39.61h31.96v-9.61zM104.23 1.13v9.64h10.47v29.97h12.73V10.77h10.47V1.13h-33.67z" fill="#fff"></path><path d="M89.75 30.5c-2.8 2.33-8.08-.25-10.16-2.38l-7.56 7.18.48.48c6.71 6.62 20.86 8.59 27.98 2.21 5.84-4.61 6.03-14.52-.04-18.59-2.29-1.46-5.4-2.86-7.97-3.52-1.31-.3-2.64-.73-3.53-1.25-2.85-1.53-.43-4.43 2.13-4.16 2.59 0 4.17 1.16 4.99 2l7.58-7.2-.14-.16C97.4-.99 84.27-1.92 77.89 3.77c-2.9 2.51-4.35 5.47-4.35 8.85-.16 8.34 7.15 11.23 13.83 13.19 1.42.6 3.28.97 3.44 2.47-.01.87-.36 1.61-1.06 2.22zM71.52 68.52c-.19 6.29-9.33 6.29-9.52 0V44.99H49.18v22.93c-.03 9.76 8.2 17.54 17.92 17.12 9.46 0 17.12-7.66 17.12-17.12V45h-12.7v23.52zM106.13 58.47 97.73 45H84.89l14.83 25.47v14.14h12.81V70.46L127.36 45h-12.84l-8.39 13.47z" fill="#fff"></path></svg></Link>
    <Link  onClick={handleClickNav} className=" border-none  menu position-fixed ms-6 text-white fw-bolder fs-5 text-decoration-none ms-2"  >
    <GiHamburgerMenu/> MENU
    </Link>

<ul className="navbar-nav">
    <li className="nav-item text-white fw-bold fs-1 ms-5 d-lg-none">
        <Link style={{textDecoration:"none",color:"white"}} to="/cart">    <button type="button" className="btn btn-primary position-relative">
       <span className="cartIcon text-white fw-bolder"> <HiOutlineShoppingCart/></span> {cart.length===0?
        (null):
        (<span className=" badge position-absolute top-0 start-100 translate-middle p-1   bg-danger border border-light rounded-circle"> {cart.length}
    <span className="visually-hidden">New alerts</span>
  </span>)}
  
</button>  <span className="fs-5" >  Cart   </span> </Link> 
    
        </li>
        </ul>

    <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
      <ul className="navbar-nav me-auto mb-2 col-9">
        <li className="nav-item col-7">
        <form className="d-flex" role="search">
        <input className="form-control col-lg-12 ms-4" type="search" placeholder="Search BestBuy" aria-label="Search" />
   
<span className="position-fixed searchIcon"> <IoIosSearch/></span>
     
      </form>
        </li>
      
      </ul>

      <ul className="navbar-nav  ">
        <li className="nav-item text-white fw-bold fs-1 d-sm-none d-md-none d-lg-block">
      <IoMdSave/>  <span className="fs-5"> Hato Rey</span>
        </li>
      
        <li className="nav-item text-white fw-bold fs-1 ms-5">
        <Link style={{textDecoration:"none",color:"white"}} to="/cart">    <button type="button" className="btn btn-primary position-relative">
       <span className="cartIcon text-white fw-bolder"> <HiOutlineShoppingCart/></span> {cart.length===0?
        (null):
        (<span className=" badge position-absolute top-0 start-100 translate-middle p-1   bg-danger border border-light rounded-circle"> {cart.length}
    <span className="visually-hidden">New alerts</span>
  </span>)}
  
</button>  <span className="fs-5" >  Cart   </span> </Link> 
    
        </li>
       

      </ul>
     

    
    </div>
  </div>
  {
    toggleNav&&(<div className="triangle ms-5 position-fixed">
  
  </div>)
  }
  
</nav>

{toggleNav&&(
  <div className="navHide fixed-top bg-white  container-fluid text-decoration-none">

<div className="signIn p-3  border-bottom container-fluid">
<div className="border-bottom pb-2">
<Link to="/signin" onClick={()=>{
setToggleNav(false);

} }>Sign in</Link> | <Link to="/signup"  onClick={()=>{
setToggleNav(false);

} }>Create account</Link>
</div>
<div className="row row-cols-1 ">
  
  <div className="col  border border-1 mt-3 border ">
    <Link className=" d-flex">
    <div>
    <p className="mt-3 ps-2 fw-bolder fs-6">
      Holiday Deals 
    </p>
    </div>
   
    <div className="ms-auto  fs-1 fw-lighter" > <svg aria-hidden="true" role="img" viewBox="0 0 100 100" width="25" height="25" fill="#0046be"><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M11.38 29.32a.98.98 0 0 1-.78-1.57L19.46 16 10.6 4.25a.98.98 0 0 1 1.57-1.17l9.3 12.33c.26.35.26.83 0 1.18l-9.3 12.34a.98.98 0 0 1-.79.39"></path></svg></svg></div>
    </Link>
  </div>
  

  <div className="col  border border-1 mt-3 border ">
    <Link className=" d-flex">
    <div>
    <p className="mt-3 ps-2 fw-bolder fs-6">
      Holiday Deals 
    </p>
    </div>
   
    <div className="ms-auto  fs-1 fw-lighter" > <svg aria-hidden="true" role="img" viewBox="0 0 100 100" width="25" height="25" fill="#0046be"><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M11.38 29.32a.98.98 0 0 1-.78-1.57L19.46 16 10.6 4.25a.98.98 0 0 1 1.57-1.17l9.3 12.33c.26.35.26.83 0 1.18l-9.3 12.34a.98.98 0 0 1-.79.39"></path></svg></svg></div>
    </Link>
  </div>


  <div className="col  border border-1 mt-3 border ">
    <Link className=" d-flex">
    <div>
    <p className="mt-3 ps-2 fw-bolder fs-6">
   Shop by Department
    </p>
    </div>
   
    <div className="ms-auto  fs-1 fw-lighter" > <svg aria-hidden="true" role="img" viewBox="0 0 100 100" width="25" height="25" fill="#0046be"><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M11.38 29.32a.98.98 0 0 1-.78-1.57L19.46 16 10.6 4.25a.98.98 0 0 1 1.57-1.17l9.3 12.33c.26.35.26.83 0 1.18l-9.3 12.34a.98.98 0 0 1-.79.39"></path></svg></svg></div>
    </Link>
  </div>


  <div className="col  border border-1 mt-3 border ">
    <Link className=" d-flex">
    <div>
    <p className="mt-3 ps-2 fw-bolder fs-6">
    Deals 
    </p>
    </div>
   
    <div className="ms-auto  fs-1 fw-lighter" > <svg aria-hidden="true" role="img" viewBox="0 0 100 100" width="25" height="25" fill="#0046be"><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M11.38 29.32a.98.98 0 0 1-.78-1.57L19.46 16 10.6 4.25a.98.98 0 0 1 1.57-1.17l9.3 12.33c.26.35.26.83 0 1.18l-9.3 12.34a.98.98 0 0 1-.79.39"></path></svg></svg></div>
    </Link>
  </div>


  <div className="col  border border-1 mt-3 border ">
    <Link className=" d-flex">
    <div>
    <p className="mt-3 ps-2 fw-bolder fs-6">
 Support & Services
    </p>
    </div>
   
    <div className="ms-auto  fs-1 fw-lighter" > <svg aria-hidden="true" role="img" viewBox="0 0 100 100" width="25" height="25" fill="#0046be"><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M11.38 29.32a.98.98 0 0 1-.78-1.57L19.46 16 10.6 4.25a.98.98 0 0 1 1.57-1.17l9.3 12.33c.26.35.26.83 0 1.18l-9.3 12.34a.98.98 0 0 1-.79.39"></path></svg></svg></div>
    </Link>
  </div>

  <div className="col  border border-1 mt-3 border ">
    <Link className=" d-flex">
    <div>
    <p className="mt-3 ps-2 fw-bolder fs-6">
    Brands
    </p>
    </div>
   
    <div className="ms-auto  fs-1 fw-lighter" > <svg aria-hidden="true" role="img" viewBox="0 0 100 100" width="25" height="25" fill="#0046be"><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M11.38 29.32a.98.98 0 0 1-.78-1.57L19.46 16 10.6 4.25a.98.98 0 0 1 1.57-1.17l9.3 12.33c.26.35.26.83 0 1.18l-9.3 12.34a.98.98 0 0 1-.79.39"></path></svg></svg></div>
    </Link>
  </div>


  <div className="col  border border-1 mt-3 border ">
    <Link className=" d-flex">
    <div>
    <p className="mt-3 ps-2 fw-bolder fs-6">
    Featured
    </p>
    </div>
   
    <div className="ms-auto  fs-1 fw-lighter" > <svg aria-hidden="true" role="img" viewBox="0 0 100 100" width="25" height="25" fill="#0046be"><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M11.38 29.32a.98.98 0 0 1-.78-1.57L19.46 16 10.6 4.25a.98.98 0 0 1 1.57-1.17l9.3 12.33c.26.35.26.83 0 1.18l-9.3 12.34a.98.98 0 0 1-.79.39"></path></svg></svg></div>
    </Link>
  </div>
  <div className="col  border border-1 mt-3 border ">
    <Link className=" d-flex">
    <div>
    <p className="mt-3 ps-2  fs-6">
      Account 
    </p>
    </div>
   
    
    </Link>
  </div>


  <div className="col  border border-1 mt-3 border ">
    <Link className=" d-flex">
    <div>
    <p className="mt-3 ps-2  fs-6">
    Order Status
    </p>
    </div>
   
    
    </Link>
  </div>



  <div className="col  border border-1 mt-3 border ">
    <Link className=" d-flex">
    <div>
    <p className="mt-3 ps-2  fs-6">
    Recently Viewed 
    </p>
    </div>
   
    
    </Link>
  </div>



  <div className="col  border border-1 mt-3 border ">
    <Link className=" d-flex">
    <div>
    <p className="mt-3 ps-2  fs-6">
      Saved Items
    </p>
    </div>
   
    
    </Link>
  </div>


</div>

</div>


</div>
)
}



<div className="d-lg-flex d-none text-decoration-none header justify-content-around p-2">
<div className=" ">
<Link>Holiday Deals <IoMdArrowDropdown/></Link>
<Link>Top Deals</Link>

<Link>Top Deals</Link>
<Link>Deal of the Day</Link>
<Link>Totaltech Membership</Link>  

<Link>Credit card</Link>
<Link>Gift card</Link>  
<Link>More <IoMdArrowDropdown/></Link>  

</div> 
<div className="fw-bold fs-5">
  <Link><HiUserCircle/>
  {userName===""?
  (<>Account</>):userName
  }
  {userName}</Link>

<Link>Recently Viewed</Link>
<Link>Order Status</Link>
<Link>Saved Items</Link>
</div>
</div>


</>
  );
}

export default Navigation;
